import { HttpClient } from '@angular/common/http';

import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class InstrumentationService {

    constructor(private http: HttpClient) {
    }
    findOne(idInstrumentation: number): Observable<any> {
        const url = environment.coreUrl + `/instrumentation/${idInstrumentation}`;

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    findAllProtocol(): Observable<any> {
        const url = environment.coreUrl + '/instrumentation/protocol';

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    findAllExecution(): Observable<any> {
        const url = environment.coreUrl + '/instrumentation/execution';

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}
